var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M3.33 8.98l5.69 4.53L14.67 18V0L9.02 4.49z"}})}
var staticRenderFns = []

export { render, staticRenderFns }